import { useAuth } from '../hooks/useAuth'
import styles from './perfil.module.scss'
import { AlunoPerfilPage } from './aluno.page'
import { StudentsRegistered } from './admin/pages/institutions/studentsRegistered'

export function PerfilPage() {
  const { student, institution } = useAuth()
  return (
    <div className={styles.main_container}>
      {student && <AlunoPerfilPage />}
      {institution && <StudentsRegistered institution={institution} />}
    </div>
  )
}
